import Base from 'app/views/base';

import tmpl from 'templates/credential_management';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize(options) {
    this.key = options.key;
  },

  context() {
    return {
      base: this.key,
      fields: this.standardizeFields(),
    };
  },

  standardizeFields() {
    const typeMap = { fake: 'hidden', password: 'password', checkbox: 'checkbox' };
    const standardized = {};

    const credentials = this.model.get('fields')[this.key];
    Object.keys(credentials).forEach(key => {
      const options = credentials[key];
      standardized[key] = {
        type: typeMap[options.visibility] || 'text',
        label: options.label,
        labelName: `${this.key}_${key}`,
        value: (options.visibility === 'fake' && !options.value) ? '9999' : options.value,
      };
    });

    return standardized;
  },

  getFullData() {
    return this.assembleData(true);
  },

  getUpdateData() {
    return this.assembleData(false);
  },

  assembleData(forCreate) {
    const data = {};

    const credentials = this.model.get('fields')[this.key];
    Object.keys(credentials).forEach(key => {
      const options = credentials[key];
      let value;
      if (options.visibility === 'checkbox') {
        value = (this.$(`input#${this.key}_${key}`).is(':checked') ? '1' : '0');
      } else {
        value = this.$(`input#${this.key}_${key}`).val();
      }
      if (forCreate || value !== options.value) {
        data[key] = value;
      }
    });
    return data;
  },
});



// WEBPACK FOOTER //
// ./app/views/credential_management_view.js